import React from 'react';
import { Hero } from '../components/home/Hero';
import { Problem } from '../components/home/Problem';
import { ThreeSystems } from '../components/home/ThreeSystems';
import { OriginSystem } from '../components/home/OriginSystem';
import { DemoSection } from '../components/home/DemoSection';
import { ResultSection } from '../components/home/ResultSection';
import { Voice } from '../components/home/Voice';
import { PricingDetail } from '../components/home/PricingDetail';
import { Applications } from '../components/home/Applications';
import { WhyOrigen } from '../components/home/WhyOrigen';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  return <div className="w-full" data-id="element-301" data-mp="2dhqfql27rtd5">
      <Hero data-id="element-302" data-mp="2dhytsga2p4px" />
      <Problem data-id="element-303" data-mp="2dii1l460ecq8" />
      <ThreeSystems data-id="element-304" data-mp="2dj1lgqf7zb6w" />
      <OriginSystem data-id="element-305" data-mp="2dfdt3uligutr" />
      <DemoSection data-id="element-306" data-mp="3kvk3cdh3kp2t" />
      <ResultSection data-id="element-307" data-mp="3ku8qlo5oc6zk" />
      <Voice data-id="element-308" data-mp="3kuqu95uo1nhi" />
      <PricingDetail data-id="element-309" data-mp="3kxd2l7pds70s" />
      <Applications data-id="element-310" data-mp="3owvljxxn680z" />
      <WhyOrigen data-id="element-311" data-mp="3owcdra1ph00o" />
      <FinalCTA data-id="element-312" data-mp="3ovud8180fzmy" />
    </div>;
}